import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from '~/components/App';
import HomeContainer from '~/components/content/HomeContainer';
import StaffContainer from '~/components/content/StaffContainer';
import PlatformsPageContainer
    from '~/components/content/containers/PlatformsPageContainer';
import PlatformMainContainer
    from '~/components/content/platform/PlatformMainContainer';
import ReviewsPageContainer
    from '~/components/content/containers/ReviewsPageContainer';
import ReviewMainContainer
    from '~/components/content/review/ReviewMainContainer';

export default (
    <Route path="/" component={ App }>
        <IndexRoute component={ HomeContainer } />

        <Route path="/platforms">
            <IndexRoute component={ PlatformsPageContainer } />
            <Route path=":slug" component={ PlatformMainContainer } />
        </Route>

        <Route path="/reviews">
            <IndexRoute component={ ReviewsPageContainer } />
            <Route path=":slug" component={ ReviewMainContainer } />
        </Route>

        <Route path="/staff(/:slug)" component={ StaffContainer } />
    </Route>
);



// WEBPACK FOOTER //
// ./src/shared/routes.js